import React from 'react';
import './Spinner.scss';

const Spinner = () => {
  return (
    <div className="loader-container">
      <div className="loader"></div>
    </div>
  );
};

export default Spinner;
